import React, { ReactNode } from 'react'
import clsx from 'clsx'

type HeadingProps = {
	children: ReactNode
	size?: 'lg' | '2xl' | '3xl' | '4xl' | 'xl' | 'md' | 'sm'
	className?: string
	button?: ReactNode
	subtitle?: string
}

const Heading = ({
	children,
	size = '2xl',
	className = undefined,
	button = null,
	subtitle = undefined,
}: HeadingProps) => {
	return (
		<div
			className={clsx(
				'flex',
				button ? ' items-center' : 'flex-col gap-2'
			)}
		>
			<p
				className={clsx(
					size === 'lg' ? undefined : `text-${size}`,
					'font-rubik font-bold mr-4 text-[rgba(0,0,0,0.72)] dark:text-white',
					className
				)}
			>
				{children}
			</p>
			{subtitle && (
				<p className="text-sm text-[rgba(0,0,0,0.6)] dark:text-white">
					{subtitle}
				</p>
			)}
			{button}
		</div>
	)
}

export default Heading
